/**
 * Asset classes in the member area: their colour (the row's colour bar) and a
 * short name. The first five colours come from the ACs; the others were chosen
 * for now (decision D8) and the client may change them. Ids are the hosted
 * Sharetribe categories (`publicData.categoryLevel1`).
 */
const ASSET_CLASSES = {
  resi_re: { color: '#3E6A9E', label: 'Residential Real Estate' },
  comm_re: { color: '#5A5590', label: 'Commercial Real Estate' },
  cars: { color: '#B4532F', label: 'Collectable Cars' },
  fine_wine: { color: '#8A2F4F', label: 'Fine Wine' },
  yachts: { color: '#2D7A7A', label: 'Yachts' },
  // Chosen for now (D8).
  jets: { color: '#4A6378', label: 'Jets' },
  helicopters: { color: '#6B7A3A', label: 'Helicopters' },
  watches: { color: '#9A7B2F', label: 'Watches' },
  rare_whisky: { color: '#8C5A2B', label: 'Rare Whisky' },
};

// Old values (goldBullion, privateEquity, art) and anything unknown.
const OTHER = { color: '#7A7F87', label: null };

/** Colour and label of an asset class; the hosted category name wins when given. */
export const assetClassOf = (id, categories = []) => {
  const known = ASSET_CLASSES[id] || OTHER;
  const hosted = (categories || []).find(c => c.id === id)?.name;
  return { color: known.color, label: hosted || known.label || id || '' };
};

/**
 * The listing's label (ACs: "For sale" or "Wanted"). Only search uses intent
 * wording ("Looking to buy" shows For sale listings).
 */
export const sideLabelOf = listingType =>
  listingType === 'search' ? 'Wanted' : 'For sale';

export default ASSET_CLASSES;
